<template>
  <div class="school-user-list">
    <section>
      <el-button type="primary" @click="gotoCreateUser" size="mini"
        >新建员工</el-button
      >
      <el-form
        ref="ruleForm"
        :inline="true"
        :model="ruleForm"
        class="form-style"
        size="mini"
      >
        <el-form-item label="姓名" prop="realname">
          <el-input
            v-model="form2.realname"
            placeholder="请输入姓名"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="username">
          <el-input
            v-model="form2.name"
            placeholder="请输入账号"
            style="width: 150px"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="SearchUser">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="table-style">
        <el-table
          size="mini"
          :data="UserData"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column
            align="left"
            width="100"
            prop="realname"
            label="姓名"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.realname }}</span>
            </template>
          </el-table-column>

          <el-table-column
            align="left"
            prop="name"
            label="账号"
          ></el-table-column>

          <el-table-column
            align="left"
            prop="phone_num"
            label="手机号"
          ></el-table-column>

          <el-table-column
            align="left"
            prop="roleStr"
            label="角色"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span v-for="item of scope.row.authUserRoleArr" :key="item.id"> {{
                item.authRoleInfo.name
              }} </span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.is_closed">停用</span>
              <span v-else>正常</span>
            </template>
          </el-table-column>

          <el-table-column width="200" prop="created_time" label="创建日期">
          </el-table-column>

          <el-table-column
            width="100"
            align="center"
            fixed="right"
            label="操作"
          >
            <template slot-scope="scope">
              <el-dropdown>
                <span class="el-dropdown-link">
                  操作<i class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="!scope.row.is_principal"
                    @click.native="adminUpdateAuthUserPassword(scope.row)"
                    >重置密码</el-dropdown-item
                  >

                  <el-dropdown-item
                    v-if="!scope.row.is_closed"
                    @click.native="adminCloseAuthUser(scope.row, '1')"
                    >封号</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-else
                    @click.native="adminCloseAuthUser(scope.row, '0')"
                    >解封</el-dropdown-item
                  >

                  <el-dropdown-item @click.native="EditUser(scope.row)"
                    >编辑</el-dropdown-item
                  >

                  <el-dropdown-item
                    @click.native="adminDeleteAuthUser(scope.row)"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 30px; text-align: right">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="page_no"
          :page-size="page_size"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </section>

    <el-dialog
      :title="'员工姓名:' + tch_name"
      :visible.sync="dialogVisible1"
      width="260px"
    >
      <div style="text-align: center; margin-top: -20px">
        <el-image
          style="width: 200px; height: 200px"
          :src="code_url"
          fit="fill"
        ></el-image>
      </div>

      <div style="text-align: center">
        <span>请老师用微信扫码,绑定账号</span>
      </div>
    </el-dialog>

    <el-dialog title="添加员工" :visible.sync="dialogVisible2" width="600px">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="员工账号">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="真实姓名">
          <el-input v-model="form.realname"></el-input>
        </el-form-item>

        <el-form-item label="联系电话">
          <el-input v-model="form.phone_num"></el-input>
        </el-form-item>

        <el-form-item label="员工角色">
          <el-checkbox-group v-model="form.authRoleIds">
            <el-checkbox
              v-for="item of RoleData"
              :key="item.id"
              :label="item.id"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="adminAddOrUpdateAuthUser"
          >录 入</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  adminAddOrUpdateAuthUser,
  adminGetAuthRoleList,
  adminGetAuthUserList,
  adminDeleteAuthUser,
  adminCloseAuthUser,
  adminUpdateAuthUserPassword,
} from "@/api/admin";

export default {
  name: "sysset-user",
  data() {
    return {
      is_principal: "",
      ruleForm: {
        username: "",
        realname: "",
        state: "",
        role_id: "",
      },
      roleList: [],
      tableData: [],
      total: 0,
      page_no: 1,
      page_size: 10,

      //微信绑定
      code_url: "",
      dialogVisible1: false,
      tch_name: "",

      //添加员工
      dialogVisible2: false,
      form: {
        auth_user_id: "",
        name: "",
        nickname: "",
        realname: "",
        phone_num: "",
        authRoleIds: [],
      },
      form2: {
        name: "",

        realname: "",
      },
      RoleData: [],
      UserData: [],
    };
  },

  mounted() {
    this.adminGetAuthRoleList();
    this.adminGetAuthUserList();
    this.is_principal = this.$store.getters.is_principal;
  },
  methods: {


    SearchUser() {
      this.page_no = 1;
      this.adminGetAuthUserList();
    },

    handleCurrentChange(val)
    {
      this.page_no = val;
      this.adminGetAuthUserList()
    },

    EditUser(row) {
      console.log("编辑员工");
      console.log(row);

      this.form.auth_user_id = row.id;
      this.dialogVisible2 = true;

      this.form.name = row.name;
      this.form.realname = row.realname;
      this.form.phone_num = row.phone_num;

      this.form.authRoleIds = [];
      for (let k = 0; k < row.authUserRoleArr.length; k++) {
        this.form.authRoleIds.push(row.authUserRoleArr[k].auth_role_id);
      }
    },

    adminAddOrUpdateAuthUser() {
      console.log("录入员工");
      console.log(this.form);

      if (!this.form.auth_user_id) {
        adminAddOrUpdateAuthUser({
          name: this.form.name,
          nickname: this.form.nickname,
          realname: this.form.realname,
          phone_num: this.form.phone_num,
          authRoleIds: JSON.stringify(this.form.authRoleIds),
        }).then((res) => {
          console.log("新增员工");
          console.log(res);
          if (res.is_create) {
            this.dialogVisible2 = false;
            this.$message.success("添加成功");
            this.adminGetAuthUserList();
          }
        });
      } else {
        adminAddOrUpdateAuthUser({
          auth_user_id: this.form.auth_user_id,
          name: this.form.name,
          nickname: this.form.nickname,
          realname: this.form.realname,
          phone_num: this.form.phone_num,
          authRoleIds: JSON.stringify(this.form.authRoleIds),
        }).then((res) => {
          console.log("更新员工");
          console.log(res);
          if (res.is_update) {
            this.dialogVisible2 = false;
            this.$message.success("更新成功");
            this.adminGetAuthUserList();
          }
        });
      }
    },

    adminGetAuthRoleList() {
      adminGetAuthRoleList().then((res) => {
        console.log("查询角色列表");
        console.log(res);
        this.RoleData = res.role_list;
      });
    },

    adminGetAuthUserList() {
      adminGetAuthUserList({
        name: this.form2.name,
        realname: this.form2.realname,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log("员工列表");
        console.log(res);
        this.UserData = res.authUserList;
        this.total = res.total;
      });
    },

    adminDeleteAuthUser(row) {
      this.$confirm("确定删除该员工账号吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        adminDeleteAuthUser({
          auth_user_id: row.id,
        }).then((res) => {
          console.log("确定删除该员工账号吗?");
          console.log(res);
          if (res.is_delete) {
            this.$message.success("删除成功");
            this.adminGetAuthUserList();
          }
        });
      });
    },

    adminCloseAuthUser(row, cmd) {
      adminCloseAuthUser({
        auth_user_id: row.id,
        is_closed: cmd,
      }).then((res) => {
        console.log("控制员工账号");
        console.log(res);
        if (res.is_update) {
          this.$message.success("修改成功");
          this.adminGetAuthUserList();
        }
      });
    },

   
    arrayBufferToBase64(buffer) {
      let binary = "";
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary); //base64
    },

    

    adminUpdateAuthUserPassword(row) {
      console.log("重置密码");
      console.log(row);

      this.$confirm("确定重置此账号的密码为123456?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        adminUpdateAuthUserPassword({
          auth_user_id: row.id,
          password: "123456",
        }).then((res) => {
          console.log("重置密码");
          console.log(res);

          if (res.is_update) {
            this.$message.success("密码重置成功");
            this.adminGetAuthUserList();
          }
        });
      });
    },

    gotoUserInfo(row) {
      this.$router.push({
        name: "school-user-info",
        query: {
          id: row.nick_id,
        },
      });
    },
    gotoEditUerInfo(row) {
      this.$router.push({
        name: "school-edit-user-info",
        query: {
          id: row.id,
        },
      });
    },
    gotoCreateUser() {
      this.dialogVisible2 = true;
      this.form.auth_user_id = "";
    },

    
  },
};
</script>

<style lang="scss" scoped>
.school-user-list {
  margin: 10px;

  border-radius: 5px;
  background-color: #fff;
  section {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .form-style {
    margin-top: 15px;
  }
}
</style>
